import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 日志
 */
const log = {

  /**
   * 查询操作日志
   */
  getOperationLog (companyId, startTime, endTime, operatorUserId) {
    return axios.post(base.log.getOperationLog, utils.postParamsArrayToJsonString({ companyId, startTime, endTime, operatorUserId }))
  },
  /**
   * 查询登录日志
   */
  getLoginLog (startTime, endTime) {
    return axios.post(base.log.getLoginLog, utils.postParamsArrayToJsonString({ startTime, endTime }))
  },
}

export default log